import { render, staticRenderFns } from "./Large.vue?vue&type=template&id=28b204b2&scoped=true&"
import script from "./Large.vue?vue&type=script&lang=js&"
export * from "./Large.vue?vue&type=script&lang=js&"
import style0 from "./Large.vue?vue&type=style&index=0&id=28b204b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b204b2",
  null
  
)

export default component.exports